export default __webpack_public_path__ + "static/media/vcs.9f02d95a.svg";